import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { ContactMembersMenu } from "../contact/contact-members/contact-member-menu";
import {
	columnActions,
	columnContact,
	columnsWithoutActions,
} from "../contact/contact-members/table-config";

export function ContactMembers() {
	/** Hooks */

	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["contact-members"],
		queryFn: async () => {
			const response = await client.contacts.members.$get({});
			const data = await responseHandler(response);
			if (!data.contactMembers) throw new Error("Failed to fetch contact members");
			return data.contactMembers;
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={data}
				columns={[...columnContact, ...columnsWithoutActions, ...columnActions]}
				persistenceKey="contact-members-table"
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				menu={
					<ContactMembersMenu
						refetch={refetch}
						contactId={null}
					/>
				}
			/>
		</ContentBox>
	);
}
